import { Navigate } from 'react-router-dom';

import HomeView from '@/views/home_view/HomeView';

import useAppStore from '@/store/app.store';

import { appRoutes } from '@/config/appRoutes';
import { ROLES } from '@/constants/roles';
import { COMPANY_TYPE } from '@/constants/company-type';

export default function RoleBasedRedirect() {
  const user = useAppStore((state) => state.user);

  if (!user) {
    return <Navigate to={appRoutes.SIGN_IN} replace />;
  }

  if (user.role === ROLES.USER && user?.companies?.[0]?.company?.companyType?.code === COMPANY_TYPE.PRODUCER) {
    return <Navigate to={appRoutes.PRODUCER} replace />;
  }

  if (user.role === ROLES.USER && user?.companies?.[0]?.company?.companyType?.code === COMPANY_TYPE.CONSUMER) {
    return <Navigate to={appRoutes.CONSUMER} replace />;
  }

  if (user.role === ROLES.MOEVE_ADMIN || user.role === ROLES.MANAGER) {
    return <HomeView />;
  }

  return <Navigate to={appRoutes.ERROR_403} replace />;
}
